import Axios from "./index";

export const showQueue = () => {
  return Axios.get(`/user/queues`);
};

export const updateQueue = params => {
  return Axios.put(`/user/queues`, params);
};

export const deleteQueue = () => {
  return Axios.delete(`/user/queues`);
};

export const addQueueMedia = medium_id => {
  return Axios.post(`/user/queues/media`, { medium_id });
};

export const removeQueueMedia = params => {
  return Axios.delete(`/user/queues/media`, { data: params });
};

export const indexQueueMedia = params => {
  return Axios.get(`/user/queues/media`, { params });
};
